import { render } from "./PrintRequisition.vue?vue&type=template&id=01eae759"
import script from "./PrintRequisition.vue?vue&type=script&lang=js"
export * from "./PrintRequisition.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/PrintRequisition.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01eae759"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01eae759', __exports__)) {
    console.log('reload')
    api.reload('01eae759', __exports__)
  }
  
  module.hot.accept("./PrintRequisition.vue?vue&type=template&id=01eae759", () => {
    console.log('re-render')
    api.rerender('01eae759', render)
  })

}


export default __exports__